<template>
  <div class="recharge-container">
    <!-- Progress Steps -->
    <div class="steps-container">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step"
        :class="{ active: currentStep === index }"
      >
        {{ step }}
      </div>
    </div>
    <!-- success Part -->
     <div v-if="currentStep == 2" class="complete-container">
      <div class="complete-image">
        <img src="@/assets/success.gif" alt="Recharge Complete" />
      </div>
	  
      <h2 class="complete-title">充值完成</h2>
	  
      <div class="info-container">
        <div class="info-item">
          <span class="info-label">用户账号: &nbsp;</span>
          <span class="info-value">{{ userID }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">充值项目: &nbsp;</span>
          <span class="info-value">{{ selectedProject }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">充值金额: &nbsp;</span>
          <span class="info-value">{{ selectedAmount.toFixed(2) }}元</span>
        </div>
        <div class="info-item">
          <span class="info-label">实际到账: &nbsp;</span>
          <span class="info-value">{{ realGetAmount.toFixed(2) }}元</span>
        </div>
		<div class="info-item">
		  <span class="info-label">当前余额: &nbsp;</span>
		  <span class="info-value">{{ userBalance.toFixed(2) }}元</span>
		</div>
        <div class="info-item">
          <p class="success-text">
            充值已完成！
          </p>
          <button class="confirm-btn" @click="currentStep = 0">
            继续充值
          </button>
        </div>
      </div>
     </div>
    <!-- Pay Part -->
    <div v-else class="content-wrapper">
      <!-- user Number Input -->
      <div class="user-input-container">
        <div class="input-group">
          <input
            v-model="userID"
            type="tel"
            maxlength="32"
            class="user-input"
            placeholder="用户ID"
          />
          <div class="legal-info">
            <span v-if="legal == '合法用户'" class="right-icon">
              ✓
            </span>
            <span v-else class="error-icon">
              ✕
            </span>
            <span class="legal">{{ legal }}</span>
            <!-- <span class="legal-label">用户</span> -->
          </div>
        </div>
      </div>
      <!-- Project Info -->
      <div class="project-container">
        <div class="project-select">
          <strong>充值项目：</strong>
          <select v-model="selectedProject" class="project-dropdown">
            <option v-for="project in projects" :value="project" :key="project">{{ project }}</option>
          </select>
        </div>
        <div class="project-tag">
          双十一限时促销活动，充值2000元及以上额外赠送10%！
        </div>
      </div>
      <!-- Amount Selection -->
      <div class="amount-container">
        <div class="amount-grid">
          <!-- <button
            v-for="amount in amounts"
            :key="amount"
            @click="selectedAmount = amount"
            :class="[
              'amount-btn',
              selectedAmount === amount ? 'amount-btn-active' : ''
            ]"
          >
            {{ amount }}元
          </button> -->
		  <button
		    v-for="amount in amounts"
		    :key="amount"
		    @click="amountChanged(amount)"
		    :class="[
		      'amount-btn',
		      selectedAmount === amount ? 'amount-btn-active' : ''
		    ]"
		  >
		    {{ amount }}元
		  </button>
          <div class="custom-amount-wrapper">
            <input placeholder="自定义金额" @input="handleInput" />
            <span class="rmb-icon">¥</span>
          </div>
        </div>
      </div>
      <!-- Payment Amount -->
      <div class="payment-info">
        <div class="payment-amount">
          <span>支付金额：</span>
          <span class="amount">{{ calculatePaymentAmount }}元</span>
        </div>
        <div class="actual-amount" style="margin-left: 20px;">
          实际到账：{{ realGetAmount.toFixed(2) }}元
        </div>
      </div>
      <div class="payment-options">
        <h3>选择支付</h3>
        <div
          v-for="(option, index) in paymentOptions"
          :key="index"
          class="payment-option"
          @click="selectPay = option.id"
          :style="selectPay === option.id ? { borderColor: option.color } : {}"
        >
          <img :src="option.icon" :alt="option.name" class="payment-icon" />
          <span>{{ option.name }}</span>
          <div v-if="selectPay === option.id" class="check-mark">✔</div>
        </div>
      </div>
      <!-- Submit Button -->
      <div class="submit-container">
        <button @click="handleRecharge" class="submit-btn">
          开始充值
        </button>
        <p class="warning-text" style="text-align: center;">
          请仔细核对充值号码，充错号将无法退款
        </p>
      </div>
    </div>
    <!-- Comfirm Cover -->
    <div v-if="currentStep == 1" class="confirm-dialog">
      <div class="confirm-content">
        <h3 style="text-align:center;margin-bottom: 10px;">确认充值信息</h3>
        <div class="info-item">
          <span class="info-label">用户ID:</span>
          <span class="info-value">{{ confirmData.userID }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">充值项目:</span>
          <span class="info-value">{{ confirmData.projectName }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">充值金额:</span>
          <span class="info-value">{{ confirmData.paymentAmount }}元</span>
        </div>
        <div class="info-item">
          <span class="info-label">实际到账:</span>
          <span class="info-value">{{ confirmData.realGetAmount }}元</span>
        </div>
        <div class="info-item">
          <p class="warning-text" style="text-align: center;">
          请仔细核对充值号码，充错号将无法退款
          </p>
        </div>
        <div class="button-group">
          <button class="cancel-btn" @click="currentStep = 0">
            取消
          </button>
          <button class="confirm-btn" @click="processRecharge">
            {{buttonText}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入所需的库和方法
import { ref, computed, onMounted, watch } from 'vue';
import { method } from 'lodash';
import axios from 'axios';

export default {
  name: "RechargePage",
  data() {
    return {
      // 用户身份
      userID: '',
      legal: '合法用户',
      // 金额和项目
      selectedAmount: 0.00,
      realGetAmount: 0.00,
	  userBalance: 0.00,
	  checkInterval: null, // 定时器 ID
      selectedProject: '',
      projects: ['spes超市小票识别算法', 'DeepOnce智能平台', '文景工业大模型工业质检平台'],
      amounts: [50, 100, 500, 1000, 2000],
      selectPay: 'wechat',
	  buttonText: '确认充值',
	  orderNumber: '',
      paymentOptions: [
        {
          id: 'wechat',
          name: '微信支付',
          icon: require('@/assets/wechat.png'),
          color: '#abebc6'
        },
        {
          id: 'alipay',
          name: '支付宝支付',
          icon: require('@/assets/alipay.png'),
          color: '#5dade2'
        },
      ],
      confirmData: null,
      // 步骤状态
      currentStep: 0,
      steps: ['1.填写号码、金额', '2.确认并支付', '3.完成']
    };
  },
  computed: {
    // 计算支付金额
    calculatePaymentAmount() {
      return this.selectedAmount.toFixed(2);
    }
  },
  mounted() {
    this.selectedProject = this.projects[0];
  },
  methods: {
    // 验证用户是否存在
	async verifyUser() {
		// try {
		//   // 发送 POST 请求，验证用户ID是否存在
		//   const response = await axios.post(`${this.$serverUrl}pay/checkUser`, {
		// 	email: this.userID
		//   });
		  
		//   // 根据服务器的响应更新验证状态
		//   if (response.data.data.exists) {
			this.legal = '合法用户';
		//   } else {
		// 	this.legal = '用户不存在';
		//   }
		// } catch (error) {
		//   console.error('用户验证失败:', error);
		//   this.legal = '用户不存在';
		// }
	},
    // 处理自定义金额输入
    handleInput(event) {
      let value = event.target.value;
      // 替换掉非数字和小数点的字符
      value = value.replace(/[^\d.]/g, '');
      // 保证只有一个小数点
      if (value.indexOf('.') !== -1) {
        value = value.split('.').slice(0, 2).join('.');
      }
      // 保证小数点后最多有两位
      if (value.indexOf('.') !== -1) {
        const [integerPart, decimalPart] = value.split('.');
        value = decimalPart.length > 2 ? `${integerPart}.${decimalPart.slice(0, 2)}` : value;
      }
      if (value === '.') {
        value = '';
      }
      event.target.value = value;
      if (value === '') return;
      this.selectedAmount = parseFloat(value);

      if (this.selectedAmount >= 2000) {
        this.realGetAmount = this.selectedAmount * 1.1;
      } else {
        this.realGetAmount = this.selectedAmount;
      }
    },
    // 处理充值金额选项
    amountChanged(selectValue) {
      this.selectedAmount = selectValue;
      if (this.selectedAmount >= 2000) {
        this.realGetAmount = this.selectedAmount * 1.1;
      } else {
        this.realGetAmount = this.selectedAmount;
      }
    },
    // 处理开始充值
    handleRecharge() {
      if (!this.userID) {
        alert('请输入用户ID');
        return;
      }
	  if(this.legal != "合法用户"){
		  alert('当前用户不存在');
		  return;
	  }
      if (this.selectedAmount === 0) {
        alert('充值金额需要大于0');
        return;
      }
      if (this.selectPay === 'wechat') {
        alert('即将开通微信支付，请先使用支付宝进行支付！');
        return;
      }
	  
      this.confirmData = {
        userID: this.userID,
        projectName: this.selectedProject,
        paymentAmount: this.calculatePaymentAmount,
        realGetAmount: this.realGetAmount.toFixed(2),
      };
      this.currentStep = 1;
	  
	  this.buttonText = '确认充值';
	  
    },
	// 确认充值并跳到完成步骤
	async processRecharge() {
	  // 防止用户多次点击导致创建多个订单
	  if (this.buttonText === '充值中...') {
		return;
	  }
	  this.buttonText = '充值中...';

	  try {
		// 发送 POST 请求以生成订单并获取支付链接
		const response = await axios.post(`${this.$serverUrl}pay/createOrder`, {
		  email: this.userID,
		  amount: this.selectedAmount,
		  real_charge: this.realGetAmount,
		  subject: this.selectedProject,
		  payment_method: this.selectPay,
		});

		// 检查响应状态
		if (response.data.status === 200) {
		  // 声明 `url` 变量
		  const url = response.data.data.url;
		  this.orderNumber = response.data.data.orderNumber;

		  // 打开支付页面
		  const newWindow = window.open(url, '_blank');
		  console.log("url: " + url);
		  if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
			this.$alert('请允许弹窗以完成支付');
		  }
		  
		  // 启动定时器，每隔1秒检查支付状态
		  this.checkInterval = setInterval(this.checkOrderFinished, 2000);
		  
		} else {
		  this.$alert('订单生成失败：' + response.data.msg);
		}
	  } catch (error) {
		console.error('订单生成失败:', error);
	  }
	},
	async checkOrderFinished(){
		if (this.orderNumber === '' || this.currentStep !== 1) {
			clearInterval(this.checkInterval); // 停止定时器
			return;
		  }
	
		  try {
			// 发送 POST 请求以检查订单状态
			const response = await axios.post(`${this.$serverUrl}pay/checkOrder`, {
			  orderNumber: this.orderNumber,
			});
	
			// 检查响应状态
			if (response.data.status === 200) {
			  const orderStatus = response.data.data.status;
	
			  // 支付处理中
			  if (orderStatus === 0) {
				console.log('订单正在处理中...');
			  }
			  // 支付成功
			  else if (orderStatus === 1) {
				this.userBalance = response.data.data.userBalance;
				this.currentStep = 2; // 显示充值成功页面
				clearInterval(this.checkInterval); // 停止定时器
				this.$alert('支付成功！');
			  }
			  // 支付失败
			  else if (orderStatus === 2) {
				clearInterval(this.checkInterval); // 停止定时器
				this.$alert('支付失败，请重试');
			  }
			  // 其他状态（如订单无效）
			  else {
				clearInterval(this.checkInterval); // 停止定时器
				this.$alert('订单状态异常，请联系客服');
			  }
			} else {
			  this.$alert('检查订单失败：' + response.data.msg);
			  clearInterval(this.checkInterval); // 停止定时器
			}
		  } catch (error) {
			console.error('检查订单状态失败:', error);
			clearInterval(this.checkInterval); // 停止定时器
		  }
	}
  },
  watch: {
    // 监听 userID 变化，并在变化时调用 verifyUser 方法
    userID(newUserID) {
      if (newUserID) {
        this.verifyUser();
      } else {
        this.legal = ''; // 清空状态
      }
    }
  }
};
</script>



<style scoped>
.recharge-container {
  max-width: 600px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #fff;
}

.steps-container {
  display: flex;
  background: #f5f5f5;
  margin-bottom: 20px;
}

.step {
  flex: 1;
  padding: 12px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.step.active {
  background: #2196f3;
  color: white;
}

.content-wrapper {
  padding: 0 20px 20px;
}

.user-input-container {
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-input {
  flex: 1;
  height: 38px;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.user-input:focus {
  outline: none;
  border-color: #2196f3;
}

.legal-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
}

.right-icon {
  color: #4caf50;
}

.error-icon {
  color: #f5222d;
}

.legal {
  color: #333;
}

.legal-label {
  color: #999;
}

.project-container {
  margin-bottom: 20px;
  text-align: center;
}

.project-select {
  font-size: 20px;
  color: #666;
  margin-bottom: 8px;
}

.project-dropdown {
  font-size: 18px;
  border: none;
  color: #2196f3;
  outline: none;
  background: transparent;
  cursor: pointer;
  margin-bottom: 10px;
}

.project-tag {
  display: inline-block;
  padding: 4px 8px;
  background: #fff1f0;
  color: #f5222d;
  font-size: 14px;
  border-radius: 2px;
}

.amount-container {
  margin-bottom: 20px;
}

.amount-grid {
  display: flex;
  flex-wrap: wrap; /* 允许自动换行 */
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
}

.amount-btn {
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  max-width: 120px;
}

.amount-btn:hover {
  border-color: #2196f3;
}

.amount-btn-active {
  border-color: #2196f3;
  background: #e6f7ff;
  color: #2196f3;
}

.custom-amount-wrapper {
  position: relative;
  display: inline-flex;
}

.custom-amount-wrapper input {
  /* width: 100%; */
  padding-right: 1.5em;
  white-space: nowrap;
  border-radius: 4px;
  text-align: center;
  max-width: 120px;
}

.custom-amount-wrapper input::placeholder {
  text-align: center;
}

.rmb-icon {
  display: flex;
  right: 0.5em;
  color: #999;
  font-size: 1em;
  pointer-events: none;
  align-items: center;
}

.payment-info {
  margin-bottom: 20px;
}

.payment-amount {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.payment-amount .amount {
  font-size: 20px;
  font-weight: bold;
  color: #f5222d;
}

.actual-amount {
  margin-top: 4px;
  font-size: 14px;
  color: #000;
}

.submit-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.submit-btn {
  width: 100%;
  height: 40px;
  background: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background: #1976d2;
}

.warning-text {
  text-align: center;
  font-size: 12px;
  color: #f5222d;
}

/* 去除输入框数字箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}


.confirm-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.confirm-content {
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
}

.info-item {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 10px;
}

.info-label {
  font-weight: bold;
}

.info-value {
  color: #333;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.cancel-btn,
.confirm-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.cancel-btn {
  background-color: #f0f0f0;
  border: none;
}

.confirm-btn {
  background-color: #2196f3;
  color: white;
  border: none;
}

.complete-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

.complete-image {
  height: 300px;
  margin-bottom: 24px;
}

.complete-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.complete-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 24px;
}

.success-text {
  text-align: center;
  font-size: 12px;
  color: #4caf50;
}

.payment-options {
  width: 300px;
  margin: 0 auto;
  text-align: center;
}

.payment-option {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
}

.payment-info {
  display: flex;
  align-items: center;
}

.payment-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.check-mark {
  color: #00aaff;
  font-size: 16px;
  margin-left: auto;
  padding-right: 10px; /* Added padding to prevent overlap */
}
</style>